import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Box, Text, Paragraph, Popover, Heading, IconButton } from "@zillow/constellation-10";
import { IconCalculatorFilled as ForwardRef } from "../../node_modules/@zillow/constellation-icons/dist/react/filled/icon-calculator-filled.esm.js";
import { IconInfoOutline as ForwardRef$1 } from "../../node_modules/@zillow/constellation-icons/dist/react/outline/icon-info-outline.esm.js";
import { commaSeparateNumber } from "../../utils/zhl-calculator.esm.js";
import { useLastValidCashOutRefinanceValues, OUTPUTS, cashOutputs, getResult } from "./CashOutRefinanceCalculator.utils.esm.js";
const CashOutRefinanceContent = () => {
  const lastValidCashOutRefinanceValues = useLastValidCashOutRefinanceValues();
  const {
    EstimatedMaxCashOutAmount,
    combinedLoanToValue,
    adjustedCashOutEstimate
  } = lastValidCashOutRefinanceValues.calculations;
  return EstimatedMaxCashOutAmount <= 0 || combinedLoanToValue > 80 || adjustedCashOutEstimate <= 0 ? /* @__PURE__ */ jsxs(Box, { css: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    margin: "default",
    background: "bg.accent.teal.soft",
    height: "300px"
  }, children: [
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(ForwardRef, { width: 75, height: 75 }) }),
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-xs", css: {
      marginTop: "default",
      textAlign: "center"
    }, asChild: true, children: /* @__PURE__ */ jsx("p", { children: "You need more home equity to cash-out." }) }),
    /* @__PURE__ */ jsx(Box, { css: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "default",
      maxWidth: "70%"
    }, children: /* @__PURE__ */ jsx(Text, { css: {
      textAlign: "center"
    }, children: "Try paying down more of your principal to lower your loan-to-value (LTV). This will help you build up enough home equity for a cash-out refinance." }) })
  ] }) : /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsxs(Box, { css: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginTop: "default",
    width: "100%"
  }, "aria-live": "polite", "aria-atomic": "true", children: [
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", asChild: true, children: /* @__PURE__ */ jsx("p", { children: "Estimated max cash-out amount" }) }),
    /* @__PURE__ */ jsxs(Text, { textStyle: "heading-md", css: {
      margin: "default",
      color: "text.accent.green.hero"
    }, children: [
      "$",
      commaSeparateNumber(lastValidCashOutRefinanceValues.calculations.EstimatedMaxCashOutAmount)
    ] }),
    OUTPUTS.map((label, index) => /* @__PURE__ */ jsxs(Box, { css: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "default",
      marginBottom: "default",
      borderBottom: index !== OUTPUTS.length - 1 ? "1px solid" : null,
      borderColor: "border.muted",
      width: "70%"
    }, children: [
      /* @__PURE__ */ jsx(Paragraph, { children: /* @__PURE__ */ jsx(Box, { asChild: true, css: {
        display: "flex",
        flexDirection: "row",
        marginBottom: "tightest"
      }, children: /* @__PURE__ */ jsx("span", { children: label === cashOutputs.newMonthlyPayment && /* @__PURE__ */ jsxs(Fragment, { children: [
        label,
        /* @__PURE__ */ jsx(Popover, { trigger: /* @__PURE__ */ jsx(IconButton, { title: "Information about new monthly payment", shape: "circle", emphasis: "bare", size: "xs", icon: /* @__PURE__ */ jsx(ForwardRef$1, {}), "aria-label": "Information about new monthly payment" }), header: /* @__PURE__ */ jsx(Heading, { level: 6, children: "New monthly payment" }), body: /* @__PURE__ */ jsx(Paragraph, { children: "This is the principal and interest payment based on your new loan balance. Your monthly payment may also include property taxes, homeowners insurance and mortgage insurance premiums, which are not shown in this estimate." }) })
      ] }) || label }) }) }),
      /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", children: getResult(label, lastValidCashOutRefinanceValues) })
    ] }, index))
  ] }) });
};
export {
  CashOutRefinanceContent as default
};
